import script from "./OptionQuotes.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionQuotes.vue?vue&type=script&setup=true&lang=js"

import "./OptionQuotes.vue?vue&type=style&index=0&id=9a4340de&lang=scss"

const __exports__ = script;

export default __exports__